<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Add Category'"
    :submit-button-text="'ADD'"
    :submit-disabled="false"
    :reset-modal="resetModal"
    :submit-modal="createCategory"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          Add a question category for this course's exams -- this category and
          its subcategories (if applicable) will be selectable when you create
          exams for this course
        </p>
      </b-col>
    </b-row>
    <category-form :category="newCategory" />
    <b-row v-if="createCategoryError">
      <b-col>
        <p class="tsny_text">
          Something went wrong adding your category. Go harass your dev
        </p>
      </b-col>
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../../TsnyModal";
import CourseRestService from "../../../services/rest/services/CourseRestService";
import CategoryForm from "./CategoryForm";

export default {
  name: "CreateQuestionCategoryModal",
  components: { CategoryForm, tsnyModal: TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    }
  },
  data: () => ({
    newCategory: {
      name: "",
      subcategories: []
    },
    modalId: "createCategoryModal",
    createCategoryError: false
  }),
  methods: {
    async createCategory(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.createCategoryError = false;

      try {
        let response = await CourseRestService.createCategory(
          this.courseId,
          this.newCategory
        );
        $comp.$bvModal.hide($comp.modalId);
        $comp.$emit("category-created", response.data);
      } catch (error) {
        $comp.createCategoryError = true;
        console.log(error);
      }
    },
    resetModal() {
      this.createCategoryError = false;
      this.newCategory = {
        name: "",
        subcategories: []
      };
    }
  }
};
</script>

<style scoped></style>
